import {
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import CommentItem from '../../../../../components/customElements/CommentItem'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { switchCommentsVisibility } from '../../../../../services/ApiService'
import singleRequestStore from '../../../store/SingleRequestStore'
import { RequestType } from '../../../types/Request.type'
import AddCommentForm from '../../BodyElements/AddCommentForm'
import TypedAccordion from '../elements/TypedAccordion'

type DrawerContentCommentsProps = {
  request: RequestType
}

const DrawerContentComments: FC<DrawerContentCommentsProps> = ({ request }) => {
  const { comments, getComments } = singleRequestStore
  const messagesRef = useRef<HTMLDivElement | null>(null)
  const scrollToBottom = () => {
    messagesRef.current?.scrollTo({ top: messagesRef.current?.scrollHeight })
  }

  useEffect(() => {
    scrollToBottom()
  }, [comments.length])

  const changeVisibility = async (
    _e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    await switchCommentsVisibility({
      orderId: request.id,
      show: checked,
      commentIdList: comments?.map((el) => el.id) ?? [],
    })

    await getComments(request.id)
  }

  const isChecked = (comments[0] && !comments[0].isHidden) ?? false
  const canPostComments = [1, 2, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14]
  const commentSrc = comments.length
    ? getImageSrc('comment-message')
    : getImageSrc('comment')

  return (
    <TypedAccordion
      summary={'Комментарии к заявке'}
      arrowIcon
      contentPadding={'16px 0'}
    >
      <Stack spacing={'16px'}>
        <Stack
          direction={'row'}
          spacing={'8px'}
          alignItems={'center'}
          paddingX={'16px'}
        >
          <Box component={'img'} src={commentSrc} />
          <Typography sx={{ fontWeight: 700, fontSize: '15px' }}>
            Комментарии ({comments.length})
          </Typography>
        </Stack>

        <Box sx={{ padding: '8px', backgroundColor: '#F6F6F6' }}>
          <Stack spacing={'4px'} sx={messagesContainerSx} ref={messagesRef}>
            {comments.map((comment) => (
              <CommentItem key={comment.id} comment={comment} />
            ))}
          </Stack>
        </Box>
        {!!comments.length && (
          <Box paddingX={'16px'}>
            <Box sx={checkboxContainerSx}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={changeVisibility}
                    disabled={!canPostComments}
                  />
                }
                label={
                  <Typography variant='h6' sx={{ fontWeight: '300' }}>
                    <FormattedMessage id={'Отображать установщику'} />
                  </Typography>
                }
              />
            </Box>
          </Box>
        )}
        <AddCommentForm disabled={!canPostComments} />
      </Stack>
    </TypedAccordion>
  )
}

const messagesContainerSx = {
  overflowY: 'auto',
  maxHeight: '49.9vh',
  height: '49.9vh',
  scrollbarWidth: '4px',
  scrollbarColor: '#A5A5A5 transparent',
}

const checkboxContainerSx = {
  backgroundColor: '#EDF1F5',
  borderRadius: '8px',
  paddingX: '16px',
}

export default observer(DrawerContentComments)
